/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Rename_Key_PreviewInputs */

const en_rename_key_preview = /** @type {(inputs: Rename_Key_PreviewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} becomes ${i?.to}. Old keys keep working.`)
};

const de_rename_key_preview = /** @type {(inputs: Rename_Key_PreviewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} wird zu ${i?.to}. Alte Schlüssel funktionieren weiterhin.`)
};

/**
* | output |
* | --- |
* | "{from} becomes {to}. Old keys keep working." |
*
* @param {Rename_Key_PreviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_key_preview = /** @type {((inputs: Rename_Key_PreviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Key_PreviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_key_preview(inputs)
	return en_rename_key_preview(inputs)
});